import React from "react";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import { ListItem } from "../../../components/Ui";
import { ReactComponent as MapIcon } from "../../../assets/img/map.svg";
import { ReactComponent as PolyIcon } from "../../../assets/img/polygon.svg";
import { FarmPoints } from "../../../components/Forms";
const farms = [
  { text: "Ajoutez un Champs", icon: <MapIcon />, goTo: "map" },
  //{ text: "Ajoutez un polygone", icon: <PolyIcon />, goTo: "polygon" },
];
const AddFarm = () => {
  const navigate = useNavigate();
  const [addFarm, setAddFarm] = React.useState("");

  React.useEffect(() => {
    if (addFarm === "polygon") {
      navigate("/farms/polygon");
    }
  }, [addFarm]);

  return (
    <>
      <div className="px-4 sm:px-0">
        <div className="py-16">
          <div className="relative" style={{ textAlign: "center" }}>
            <Typography variant="title">
              {/* <Trans>formTitles.selectProducts</Trans> */}
            Cliquez sur le boutton ci-dessous pour ajouter une Champs
            </Typography>
           
          </div>

          <div className="flex justify-center mt-14">
            <div className="max-w-[437px] w-full">
              {farms.map((map) => (
                <ListItem
                  key={map.text}
                  {...map}
                  iconSize={20}
                  className="p-6 mb-3"
                  chevron={false}
                  icon={map.icon}
                  onClick={() => {
                    setAddFarm(map.goTo);
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <FarmPoints
        // {...props}
        visible={addFarm === "map"}
        onCancel={() => {
          setAddFarm("");
        }}
        onSuccess={(m, v) => {
          navigate("/farms");
        }}
      />
    </>
  );
};

export default AddFarm;
